import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';

export default function Navbar() {
  return (
    <nav className="nav">
      <a href="#" className="nav-logo">
        <img src={logo} alt="شليل للألعاب" />
      </a>
      <Link to="/subscribe" className="nav-cta">
        اشترك الآن
      </Link>
    </nav>
  );
}
